module.exports = __webpack_public_path__ + "img/cnttset.16a48988.svg";